import { Char } from "../../types";

export const isDigit = (c: Char): boolean => c >= "0" && c <= "9";
